import axios from "axios";
import { BASE_URL } from "../BaseUrl.js";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("compte_admin");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

//liste des All product

export const listeDesproduct = async (page, size, param, enSolde) => {
  return await axios.get(
    `${BASE_URL}/product/allProductPagined?page=${page}&size=${size}&param=${param}&enSolde=${enSolde}`,
    {}
  );
};

export const listeDesproduct2 = async (page, size, param) => {
  return await axios.get(
    `${BASE_URL}/product/allProductPagined?page=${page}&size=${size}&param=${param}`,
    {}
  );
};

export const listeDesproductSansFiltre = async () => {
  return await axios.get(`${BASE_URL}/product/getAllProducts`, {});
};

// Enregiste des product

export const enregistrerProduitsBackoffice = async (product) => {
  return await axios.post(`${BASE_URL}/product/createProducts`, product);
};

// modifie categorie

export const modifierProduitsById = async (productId, productData) => {
  return await axios.put(
    `${BASE_URL}/product/updateProducts/${productId}`,
    productData
  );
};

export const VisitorCompteurproduct = async (productId) => {
  return await axios.put(`${BASE_URL}/product/checkVisit/${productId}`);
};
export const VisitorLikedproduct = async (productId, productData) => {
  return await axios.put(
    `${BASE_URL}/product/visitLiked/${productId}`,
    productData
  );
};

export const supprimerProduitById = async (productId) => {
  return await axios.delete(`${BASE_URL}/product/deleteProducts/${productId}`);
};

// producd by id

export const getproductById = async (productId) => {
  return await axios.get(`${BASE_URL}/product/${productId}`);
};

// export const getproductByIdBoutique = async (productId) => {
//   return await axios.get(`${BASE_URL}/product/${productId}`);
// };

export const getproductByCategorieId = async (categorieId) => {
  return await axios.get(`${BASE_URL}/product/idCategorie/${categorieId}`);
};

// idCategorie
